import request from "axios";
import { apiBase } from "../../constants";

/**
 * Send what someone typed. Only the text and which question it answers go over
 * the wire - who they are is read from the session on the server, so the
 * numbers we later read off this table cannot be shaped by the browser.
 */
export const submitFeedback = async (feedback: {
  message: string;
  prompt?: string;
}): Promise<void> => {
  await request({
    url: `${apiBase}/v1/product-feedback`,
    method: "POST",
    data: feedback,
    withCredentials: true,
    validateStatus: (status) => status < 300,
  });
};
